import { useState, useRef, useEffect } from "react";
import PrimaryButton from "../components/PrimaryButton";
import SecondaryButton from "../components/SecondaryButton";
import Modal from "../components/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCircleXmark,
    faTrashCan,
} from "@fortawesome/free-regular-svg-icons";
import axiosInstance from '../axiosConfig';
import Input from "../components/Input";
import ConfirmDeleteModal from '../components/ConfirmDeleteModal';
import { formatValue } from '../utils/formatValue';
import { faPrint, faQrcode } from '@fortawesome/free-solid-svg-icons';
import { QRCodeCanvas } from 'qrcode.react';
import { jwtDecode } from 'jwt-decode';
import { handleError } from "../services/handleError";
import { showToast } from "../components/Toast";
import Loading from "./Loading";
import ListaProdutos from '../components/ListaProdutos';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

function Mesas() {
    const [mesas, setMesas] = useState([]);
    const [itensMesa, setItensMesa] = useState([]);
    const [menuVisible, setMenuVisible] = useState(false);
    const [idMenu, setIdMenu] = useState(null);
    const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
    const [selectedMesa, setSelectedMesa] = useState(null);
    const [modalVisible, setModalVisible] = useState(false);
    const [isModalAddMesa, setIsModalAddMesa] = useState(false);
    const [isModalAddProdutoMesa, setIsModalAddProdutoMesa] = useState(false);
    const menuRef = useRef(null);
    const inputMesa = useRef(null);
    const inputCapacidadeMesa = useRef(null);
    const [modalConfirmDelete, setModalConfirmDelete] = useState(false);
    const [itemConfirmDelete, setItemConfirmDelete] = useState(false);
    const [qrModalVisible, setQrModalVisible] = useState(false);
    const [loading, setLoading] = useState(true);
    const [produtos, setProdutos] = useState([]);
    const [produtosSelecionados, setProdutosSelecionados] = useState([]);
    const qrCodeRef = useRef();

    useEffect(() => {
        buscarMesas();
    }, []);

    async function buscarMesas() {
        setLoading(true);

        try {
            const response = await axiosInstance.get("Mesas");

            setMesas(response.data)
        } catch (error) {
            handleError(error, "Erro ao buscar mesas.");
        } finally {
            setLoading(false);
        }
    };

    async function buscarItensMesa(mesaId) {
        setLoading(true);

        try {
            const response = await axiosInstance.post("Mesas/ItensMesa", { IdMesa: mesaId.id });

            setItensMesa(response.data);
            setModalVisible(true);
        } catch (error) {
            handleError(error, "Erro ao buscar itens da mesa.");
        } finally {
            setLoading(false);
        }
    };

    const handleContextMenu = (id) => (event) => {
        event.preventDefault();
        const { clientX: x, clientY: y } = event;

        const menuHeight = menuRef.current ? menuRef.current.offsetHeight : 0;
        const adjustedY = y + menuHeight > window.innerHeight ? y - menuHeight : y;

        setMenuPosition({ x, y: adjustedY });
        setMenuVisible(true);
        setIdMenu(id);
    };

    const handleClickOutTable = () => {
        setMenuVisible(false);
    };

    const formMesaSubmit = (event) => {
        event.preventDefault();
        let numero = parseInt(inputMesa.current.value, 10);
        let capacidade = parseInt(inputCapacidadeMesa.current.value, 10);

        if (!mesas.some((mesa) => mesa.numero === numero)) {
            criarMesa(numero, capacidade);
        }
        else {
            handleError("Já existe uma mesa com esse número.")
        }
    };

    async function criarMesa(numero, capacidade) {
        setLoading(true);

        try {
            const response = await axiosInstance.post("Mesas/NovaMesa", { Numero: numero, Capacidade: capacidade });

            showToast("Sucesso!", "success", 3000, "Mesa criada com sucesso");

            closeModal();

            const newMesa = {
                id: response.data,
                numero: numero,
                ocupada: false,
            };

            setMesas([...mesas, newMesa].sort((a, b) => a.id - b.id));
        } catch (error) {
            handleError(error, "Erro ao criar nova mesa.");
        } finally {
            setLoading(false);
        }
    };

    async function inativarMesa(id) {
        setLoading(true);

        try {
            await axiosInstance.delete("Mesas/InativarMesa/" + id);

            const updatedMesas = mesas.filter(mesa => mesa.id !== id);
            setMesas(updatedMesas);
        } catch (error) {
            handleError(error, "Erro ao inativar mesa.");
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteMesa = (id) => {
        const mesa = mesas.find(mesa => mesa.id === id);

        if (mesa && !mesa.ocupada) {
            inativarMesa(id);
        } else {
            handleError("A mesa não está vazia. Não é possível excluir.");
        }
    };

    const handleOpenComanda = (mesa) => {
        setSelectedMesa(mesa);
        buscarItensMesa(mesa);
    };

    const handleDeleteProduct = (productIndex) => {
        setModalConfirmDelete(true);
        setItemConfirmDelete(itensMesa[0].itensPedido[productIndex]);
    };

    const handleConfirmDelete = async () => {
        setModalConfirmDelete(false);
        setLoading(true);

        try {
            await axiosInstance.put("Pedidos/RemoverProduto/" + itemConfirmDelete.id);
            buscarItensMesa({ id: selectedMesa.id });
            showToast("Sucesso!", "success", 3000, "Produto removido com sucesso");
        } catch (error) {
            handleError(error, "Erro ao remover produto.");
        } finally {
            setLoading(false);
        }
    };

    const handleAddProduct = (item, quantidade, observacao) => {
        const novoProduto = {
            produto: {
                MetadeProdutoId: item.metade,
                id: item.id,
                url_Imagem: item.url_Imagem,
                titulo: item.titulo,
                valor: item.valor,
                adicionais: item.adicionais,
                porKg: item.porKg
            },
            quantidade,
            observacao
        };

        setProdutosSelecionados(prevProdutos => [...prevProdutos, novoProduto]);
    };

    async function buscarProdutos() {
        setLoading(true);

        try {
            const response = await axiosInstance.get("Produto/GetProdutos");

            setProdutos(response.data)
        } catch (error) {
            handleError(error, "Erro ao buscar produtos.");
        } finally {
            setLoading(false);
        }
    };

    const handleCloseComanda = async (mesa) => {
        setLoading(true);

        try {
            await axiosInstance.put("Mesas/FecharComanda", { IdMesa: mesa });

            showToast("Sucesso!", "success", 3000, "Comanda fechada com sucesso");

            const updatedMesas = mesas.map(mesa =>
                mesa.id === selectedMesa.id
                    ? { ...mesa, ocupada: false }
                    : mesa
            );
            setMesas(updatedMesas);
            setModalVisible(false);
        } catch (error) {
            handleError(error, "Erro ao fechar comanda.");
        } finally {
            setLoading(false);
        }
    };

    const openAddMesa = () => setIsModalAddMesa(true);
    const openAddProduto = () => setIsModalAddProdutoMesa(true);

    const closeModal = () => {
        setIsModalAddMesa(false);
        setIsModalAddProdutoMesa(false);
        setModalConfirmDelete(false);
    };

    const token = localStorage.getItem('token');
    let lanchonete = '';
    if (token) {
        try {
            const decodedToken = jwtDecode(token);
            lanchonete = decodedToken.restaurante;
        } catch (error) {
            handleError(error, "Erro ao parsear token.")
        }
    }

    const handlePrint = () => {
        const qrCanvas = qrCodeRef.current.querySelector('canvas');
        if (qrCanvas) {
            const qrImage = qrCanvas.toDataURL('image/png'); // Converte para base64

            // Conteúdo da nova aba
            const printContent = `
                <html>
                    <head>
                        <title>Imprimir QR Code</title>
                        <style>
                            body {
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                height: 100vh;
                                margin: 0;
                                font-family: Arial, sans-serif;
                                text-align: center;
                            }
                            .container {
                                display: flex;
                                flex-direction: column;
                                justify-content: center;
                                align-items: center;
                            }
                            h1 {
                                margin-bottom: 20px;
                                font-size: 1.5rem;
                            }
                            img {
                                width: 256px;
                                height: 256px;
                            }
                        </style>
                    </head>
                    <body>
                        <div class="container">
                            <h1>Faça seu pedido!</h1>
                            <img src="${qrImage}" alt="QR Code da Mesa ${selectedMesa?.numero}" />
                            <h1>Mesa ${selectedMesa?.numero}</h1>
                        </div>
                        <script>
                            window.onload = function() {
                                window.print();
                                setTimeout(() => window.close(), 100); // Fecha a aba após a impressão
                            }
                        </script>
                    </body>
                </html>
            `;

            // Abre uma nova aba temporária para impressão
            const printWindow = window.open('', '_blank');
            printWindow.document.write(printContent);
            printWindow.document.close();
        }
    };

    const handleConfirmarPedidoMesa = async () => {
        if (produtosSelecionados.length === 0)
            return handleError("Selecione um produto!");

        setLoading(true);

        produtosSelecionados.forEach(produto => {
            produto.MetadeProdutoId = produto.produto.MetadeProdutoId;
            produto.Adicionais = produto.produto.adicionais
                ?.filter(a => a.adicionado)
                .map(a => a.id)
                .join(",") || "";
        });

        try {
            await axiosInstance.post("Pedidos/AddProdutosMesa", { MesaId: selectedMesa.id, Produtos: produtosSelecionados });
            showToast("Sucesso!", "success", 3000, "Produto adicionado com sucesso");
            setIsModalAddProdutoMesa(false);
            buscarItensMesa({ id: selectedMesa.id });
            setProdutosSelecionados([]);
        } catch (error) {
            handleError(error, "Erro ao adicionar.");
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <Loading />;
    }

    return (
        <>
            <ConfirmDeleteModal
                isOpen={modalConfirmDelete}
                onClose={closeModal}
                onConfirm={handleConfirmDelete}
                itemName={itemConfirmDelete && itemConfirmDelete.produto && itemConfirmDelete.produto.titulo}
            />

            <Modal isOpen={isModalAddMesa} onClose={closeModal}>
                <div className="text-black mb-2 flex justify-between items-center">
                    <span className="text-xl font-semibold">Nova Mesa</span>
                    <button className="" onClick={() => closeModal()}>
                        <FontAwesomeIcon icon={faCircleXmark} className="text-3xl" />
                    </button>
                </div>
                <div className="rounded-full bg-gray-300 my-2" style={{ height: '2.5px' }} />
                <form onSubmit={formMesaSubmit}>
                    <div className="space-y-2">
                        <div className="space-y-2 sm:space-y-0 sm:flex sm:space-x-2">
                            <Input placeholder="Informe o número da mesa" size="medium" referencia={inputMesa} />
                            <Input placeholder="Informe a capacidade da mesa" size="medium" referencia={inputCapacidadeMesa} />
                        </div>
                    </div>
                    <div className="flex items-center justify-between space-x-2 mt-3">
                        <SecondaryButton onClick={() => closeModal()}>
                            Cancelar
                        </SecondaryButton>
                        <PrimaryButton>
                            Cadastrar
                        </PrimaryButton>
                    </div>
                </form>
            </Modal>

            <Modal isOpen={isModalAddProdutoMesa} onClose={closeModal} zIndex={35}>
                <div className="text-black mb-2 flex justify-between items-center">
                    <span className="text-xl font-semibold">Adicionar Produto</span>
                    <button className="" onClick={() => closeModal()}>
                        <FontAwesomeIcon icon={faCircleXmark} className="text-3xl" />
                    </button>
                </div>
                <div className="rounded-full bg-gray-300 my-2" style={{ height: '2.5px' }} />
                <div className="w-full h-16 sm:h-12 items-center flex justify-between mb-4">
                    <FontAwesomeIcon icon={faArrowLeft} className="mr-2 fa-xl border p-1 rounded cursor-pointer" onClick={() => { setIsModalAddProdutoMesa(false); setProdutosSelecionados([]) }} />

                    <span className='font-regular sm:text-xl'>Selecione os Produtos</span>

                    <button
                        disabled={produtosSelecionados.length === 0}
                        onClick={() => handleConfirmarPedidoMesa()}
                        className={`py-1 text-white font-regular px-2 sm:px-4 rounded-lg 
                                                bg-blue-700 hover:bg-blue-800 active:bg-blue-900 
                                                focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 
                                                shadow-md transition-all duration-200 ease-in-out 
                                                transform hover:scale-105 active:scale-95 whitespace-nowrap
                                                ${produtosSelecionados.length === 0 ? 'opacity-50 cursor-not-allowed hover:scale-100' : ''}`}
                    >
                        Confirmar
                    </button>
                </div>
                <div>
                    <ListaProdutos produtos={produtos} onAddProduct={handleAddProduct} />
                </div>
            </Modal>

            <div className="p-5" onClick={handleClickOutTable}>
                <div className="flex flex-wrap justify-between">
                    <div className="flex items-center">
                        <span className="text-xl font-semibold">Mesas:</span>
                    </div>
                    <div className="flex space-x-2 mb-2">
                        <PrimaryButton onClick={() => openAddMesa()}>
                            Nova Mesa
                        </PrimaryButton>
                    </div>
                </div>

                <div className="flex flex-wrap gap-4">
                    {mesas.length === 0 &&
                        <>
                            Não há nenhuma mesa cadastrada.
                        </>
                    }
                    {mesas.map((mesa) => (
                        <div
                            key={mesa.id}
                            className={`select-none hover:scale-105 shadow-md transition-all duration-200 ease-in-out transform active:scale-95 cursor-pointer rounded-[10px] w-32 h-24 text-white items-center justify-center flex ${mesa.ocupada ? "bg-red-600" : "bg-green-600"}`}
                            onContextMenu={handleContextMenu(mesa.id)}
                            onClick={() => handleOpenComanda(mesa)}
                        >
                            Mesa {mesa.numero}
                        </div>
                    ))}
                    {menuVisible && (
                        <ul
                            ref={menuRef}
                            className="absolute bg-white shadow-xl rounded space-y-2 border"
                            style={{ top: `${menuPosition.y}px`, left: `${menuPosition.x}px` }}
                        >
                            <li className="p-2 px-4 hover:bg-gray-200 cursor-pointer rounded" onClick={() => handleDeleteMesa(idMenu)}>Excluir</li>
                        </ul>
                    )}
                </div>
            </div>

            <Modal isOpen={modalVisible} onClose={() => setModalVisible(false)}>
                <div className="text-black mb-2 flex justify-between items-center">
                    <span className="text-xl font-semibold">Mesa {selectedMesa?.numero}</span>
                    <div className="flex justify-end mb-2">
                        <button
                            onClick={() => setQrModalVisible(true)}
                            className="bg-blue-700 hover:bg-blue-800 text-white text-sm py-1 px-2 rounded shadow flex items-center"
                        >
                            <FontAwesomeIcon icon={faQrcode} className="mr-1" />
                            Ver QR Code
                        </button>
                    </div>
                    <button onClick={() => setModalVisible(false)}>
                        <FontAwesomeIcon icon={faCircleXmark} className="text-3xl" />
                    </button>
                </div>
                <div className="rounded-full bg-gray-300 my-2" style={{ height: '2px' }} />

                <div className="flex justify-between items-center mb-4">
                    <span className="text-lg font-semibold">Produtos:</span>
                    <button
                        onClick={() => { openAddProduto(); buscarProdutos(); }}
                        className="bg-blue-700 hover:bg-blue-800 active:bg-blue-900 text-white text-sm py-1 px-2 rounded shadow"
                    >
                        Adicionar Produto
                    </button>
                </div>

                <div className="space-y-2 my-4">
                    {itensMesa.length > 0 ? (
                        <ul>
                            {itensMesa.map((pedido, pedidoIndex) => (
                                pedido.itensPedido.map((item, itemIndex) => (
                                    <li key={`${pedidoIndex}-${itemIndex}`} className="flex justify-between items-center mt-2">
                                        <span className="text-md sm:text-lg">{String(item.quantidade).padStart(2, "0")}{item.produto?.porKg ? "kg" : "x"} {item.produto.titulo} - {item.produto.porKg ? formatValue(item.precoUnitario) : formatValue(item.precoUnitario * item.quantidade)}</span>
                                        <div className="space-x-4">
                                            <button onClick={() => handleDeleteProduct(itemIndex)} className="pr-1 text-red-500 hover:text-red-600 hover:scale-110 transition-all duration-200 ease-in-out transform">
                                                <FontAwesomeIcon icon={faTrashCan} className="text-2xl" />
                                            </button>
                                        </div>
                                    </li>
                                ))
                            ))}
                        </ul>
                    ) : (
                        <p>A comanda está vazia.</p>
                    )}
                </div>

                {/* Cálculo do Total */}
                {itensMesa.length > 0 &&
                    <div className="flex justify-end text-lg font-semibold mt-4">
                        <span>Total: {formatValue(itensMesa[0]?.valorTotal)}</span>
                    </div>
                }

                <div className="flex items-center justify-between space-x-2 mt-3">
                    <SecondaryButton onClick={() => setModalVisible(false)}>Cancelar</SecondaryButton>
                    <PrimaryButton onClick={() => handleCloseComanda(selectedMesa.id)}>Fechar Comanda</PrimaryButton>
                </div>
            </Modal>

            <Modal isOpen={qrModalVisible} onClose={() => setQrModalVisible(false)}>
                <div className="text-black flex justify-between items-center mb-4">
                    <span className="text-xl font-semibold">QR Code da Mesa {selectedMesa?.numero}</span>
                    <button onClick={() => setQrModalVisible(false)}>
                        <FontAwesomeIcon icon={faCircleXmark} className="text-3xl" />
                    </button>
                </div>

                {/* QR Code */}
                <div ref={qrCodeRef} className="flex justify-center my-4">
                    <QRCodeCanvas
                        value={`https://sistema.cardapti.com.br/qrcode/${lanchonete}/${selectedMesa?.numero}`}
                        size={256}
                        bgColor="#FFFFFF"
                        fgColor="#000000"
                        level="H"
                    />
                </div>

                {/* Botão de impressão */}
                <div className="flex justify-end">
                    <button
                        onClick={handlePrint}
                        className="bg-green-600 hover:bg-green-700 text-white py-1 px-3 rounded flex items-center"
                    >
                        <FontAwesomeIcon icon={faPrint} className="mr-2" />
                        Imprimir QR Code
                    </button>
                </div>
            </Modal>
        </>
    );
}

export default Mesas;
